import { render, staticRenderFns } from "./bo-attachment.vue?vue&type=template&id=033d3e1f"
import script from "./bo-attachment.vue?vue&type=script&lang=js"
export * from "./bo-attachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports